'use client';

import { Session } from 'next-auth';
import { NosAgentsHero } from './components/hero-section';
import { AgentsShowcase } from './components/static-sections';

interface NosAgentsClientProps {
    initialSession: Session | null;
}

export default function NosAgentsClient({ initialSession }: NosAgentsClientProps) {
    return (
        <div className="min-h-screen bg-gradient-to-b from-teal-50 via-white to-green-50">
            {/* Interactive Hero Section - only needs session */}
            <NosAgentsHero initialSession={initialSession} />

            {/* Static Content - no session needed */}
            <AgentsShowcase />
        </div>
    );
}
